import React from "react";
import Loader from "react-loader-spinner";
const LoadingIndicator = () => {
  return (
    <div
      className="DasboardContentContainer"
      style={{ alignItems: "flex-start" }}
    >
      <Loader type="ThreeDots" color="#fe9929" height="80" width="80" />
    </div>
  );
};
export default LoadingIndicator;
